// Collapsible scope controls (environment / tenant / timezone / confidential
// access). Changing any of these starts a new chat — the page enforces it.
// Styled to the SQ-AI tokens (sqAi.module.css).

import React from "react";
import styles from "../sqAi.module.css";

const ENVS = ["dev", "stage", "prod"];

const TIMEZONES = [
  "Asia/Calcutta",
  "UTC",
  "Europe/London",
  "Europe/Paris",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "Asia/Dubai",
  "Asia/Singapore",
  "Australia/Sydney",
];

export default function SettingsBar({
  env,
  onEnvChange,
  tenants,
  tenantSchema,
  onTenantChange,
  tenantsLoading,
  tenantsError,
  confidentialAccess,
  onConfidentialChange,
  userTz,
  onUserTzChange,
  disabled,
}) {
  return (
    <div className={styles.settings}>
      <div className={styles.column}>
        <div className={styles.settingsGrid}>
          <label className={styles.field}>
            <span className={styles.fieldLabel}>Environment</span>
            <select className={styles.select} value={env} onChange={(e) => onEnvChange(e.target.value)} disabled={disabled}>
              {ENVS.map((e) => (
                <option key={e} value={e}>{e}</option>
              ))}
            </select>
          </label>

          <label className={styles.field}>
            <span className={styles.fieldLabel}>Tenant</span>
            <select
              className={styles.select}
              value={tenantSchema}
              onChange={(e) => onTenantChange(e.target.value)}
              disabled={disabled || tenantsLoading || tenants.length === 0}
            >
              {tenantsLoading && <option value="">Loading…</option>}
              {!tenantsLoading && tenants.length === 0 && <option value="">No tenants available</option>}
              {!tenantsLoading &&
                tenants.map((t) => {
                  const name = t.name || t.schema || t;
                  return (
                    <option key={name} value={name}>{name}</option>
                  );
                })}
            </select>
            {tenantsError && <span className={styles.fieldError}>{tenantsError}</span>}
          </label>

          <label className={styles.field}>
            <span className={styles.fieldLabel}>Timezone</span>
            <select className={styles.select} value={userTz} onChange={(e) => onUserTzChange(e.target.value)} disabled={disabled}>
              {!TIMEZONES.includes(userTz) && userTz && <option value={userTz}>{userTz}</option>}
              {TIMEZONES.map((tz) => (
                <option key={tz} value={tz}>{tz}</option>
              ))}
            </select>
          </label>

          <div className={styles.field}>
            <span className={styles.fieldLabel}>Access</span>
            <label className={styles.checkboxRow}>
              <input
                type="checkbox"
                checked={confidentialAccess}
                onChange={(e) => onConfidentialChange(e.target.checked)}
                disabled={disabled}
              />
              Include confidential records
            </label>
          </div>
        </div>
        <p className={styles.settingsHint}>Changing the environment, tenant, timezone, or access starts a new chat.</p>
      </div>
    </div>
  );
}
